<template>
  <div class="presentation">
    <img :src="image" />
  </div>
</template>
<script>
export default {
  name: "WelfareCooperation",
  data: function() {
    return {
      index: 0,
      image:
        "http://dayandt.oss-cn-shanghai.aliyuncs.com/welfareCooperation.jpg"
    };
  }
};
</script>
